import { useMutation, useQueryClient } from "@tanstack/react-query";

import { toast } from "@/components/toast/toast-queue.ts";
import { useFeedbackTool } from "@/features/request/feedback-tool/feedbackTool/hooks/useFeedbackTool.tsx";
import { feedbackToolKeys } from "@/hooks/queryKeys.ts";
import apiClient from "@/lib/api/client.ts";

export const useDeleteFeedbackAttachment = (
  attachmentId: number,
  parentId: number,
) => {
  const queryClient = useQueryClient();
  const { setFormFeedBack } = useFeedbackTool();

  return useMutation({
    mutationFn: async () =>
      apiClient
        .url(`/stories/feedback-tool/attachment/${attachmentId}`)
        .delete()
        .json(),
    mutationKey: feedbackToolKeys.deleteAttachment(attachmentId),
    onError: () => {
      toast.add(
        {
          description: "Please try to delete attachment again.",
          title: "Error deleting attachment",
          type: "error",
        },
        {
          timeout: 5000,
        },
      );
    },
    onSuccess: async () => {
      toast.add(
        {
          title: "Attachment deleted successfully",
          type: "success",
        },
        {
          timeout: 5000,
        },
      );

      setFormFeedBack((prevFormFeedBack) => {
        if (!prevFormFeedBack) return null;

        return {
          ...prevFormFeedBack,
          type: "VIEW",
        };
      });

      await queryClient.refetchQueries({
        exact: true,
        queryKey: feedbackToolKeys.feedbacks(parentId),
      });
    },
  });
};
